var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-mr",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#cd2a3e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 76.8h512v358.4H0z",
    fill: "#006233"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M416 164.907c-.427 87.978-71.936 159.146-160 159.146S96.427 252.885 96 164.907a165.188 165.188 0 0 0-5.376 41.813c0 91.307 73.984 165.376 165.376 165.376 91.392 0 165.376-73.984 165.376-165.376 0-14.421-1.877-28.501-5.376-41.813z",
    className: "st1",
    fill: "#ffc400"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256 100.054l-14.37 44.22-46.497.003 37.616 27.331-14.367 44.222L256 188.501l37.618 27.33-14.367-44.223 37.616-27.332-46.497-.002z",
    fill: "#ffc400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMr);
export default __webpack_public_path__ + "static/media/mr.90b044479e4dc8257adda7a4f0bbcceb.svg";
export { ForwardRef as ReactComponent };